import React from 'react'
import { Typography, Box, Divider } from '@mui/material'

const getRequestEntitlementBreakdown = (selectedLeave, leaveBalance, values, balance) => {
  switch (selectedLeave.leave_policy.type) {
    case 1:
      return (
        <Box
          sx={{
            backgroundColor: 'gray-background.main',
            borderRadius: 1.25,
            p: 2.5,
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="body1" color="light-gray-text.main">
              Available entitlement
            </Typography>
            <Typography variant="body1" color="dark-text.main">
              {selectedLeave.entitlement.balance === 1
                ? `${selectedLeave.entitlement.balance} day`
                : `${selectedLeave.entitlement.balance} days`}
            </Typography>
          </Box>
          {leaveBalance?.leave_credit[0]?.applicable_leave?.find(
            (uItem) => uItem.leave_policy_id === selectedLeave.leave_policy_id
          ) && (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },
                  justifyContent: 'space-between',
                }}
              >
                <Typography variant="body1" color="light-gray-text.main">
                  Available replacement credit
                </Typography>
                <Typography variant="body1" color="dark-text.main">
                  {leaveBalance?.leave_credit[0]?.leave_credit.balance
                    ? leaveBalance?.leave_credit[0]?.leave_credit.balance === 1
                      ? `${leaveBalance?.leave_credit[0]?.leave_credit.balance} day`
                      : `${leaveBalance.leave_credit[0].leave_credit.balance} days`
                    : '0 day'}
                </Typography>
              </Box>
            )}
          {selectedLeave.carry_forward && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'space-between',
              }}
            >
              <Typography variant="body1" color="light-gray-text.main">
                Available carry forward
              </Typography>
              <Typography variant="body1" color="dark-text.main">
                {selectedLeave.carry_forward.balance
                  ? selectedLeave.carry_forward.balance === 1
                    ? `${selectedLeave.carry_forward.balance} day`
                    : `${selectedLeave.carry_forward.balance} days`
                  : '0 day'}
              </Typography>
            </Box>
          )}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="body1" color="light-gray-text.main">
              Days to be requested
            </Typography>
            <Typography variant="body1" color="dark-text.main">
              {values.duration} {values.duration !== 1 ? 'days' : 'day'}
            </Typography>
          </Box>
          <Divider sx={{ my: 1 }} />
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="body1" color="light-gray-text.main">
              Entitlement balance upon approval
            </Typography>
            <Typography variant="body1" color="dark-text.main">
              {balance.entitlementBalance} {balance.entitlementBalance > 1 ? 'days' : 'day'}
            </Typography>
          </Box>
          {leaveBalance?.leave_credit[0]?.applicable_leave?.find(
            (uItem) => uItem.leave_policy_id === selectedLeave.leave_policy_id
          ) && (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },
                  justifyContent: 'space-between',
                }}
              >
                <Typography variant="body1" color="light-gray-text.main">
                  Replacement credit balance upon approval
                </Typography>
                <Typography variant="body1" color="dark-text.main">
                  {balance.creditBalance} {balance.creditBalance > 1 ? 'days' : 'day'}
                </Typography>
              </Box>
            )}
          {selectedLeave.carry_forward && balance.carryForwardBalance && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'space-between',
              }}
            >
              <Typography variant="body1" color="light-gray-text.main">
                Carry forward balance upon approval
              </Typography>
              <Typography variant="body1" color="dark-text.main">
                {balance.carryForwardBalance} {balance.carryForwardBalance > 1 ? 'days' : 'day'}
              </Typography>
            </Box>
          )}
        </Box>
      )
    case 2:
      return (
        <Box
          sx={{
            backgroundColor: 'gray-background.main',
            borderRadius: 1.25,
            p: 2.5,
            display: 'flex',
            flexDirection: 'column',
            rowGap: 1,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="body1" color="light-gray-text.main">
              Days to be requested
            </Typography>
            <Typography variant="body1" color="dark-text.main">
              {values.duration} {values.duration !== 1 ? 'days' : 'day'}
            </Typography>
          </Box>
        </Box>
      )

    default:
      return null
  }
}

export default getRequestEntitlementBreakdown
